export const getTaskStatus = (taskPhase: string, currentPhase: string): "pending" | "active" | "completed" => {
  const phaseOrder = ["initializing", "thinking", "retrieving", "analyzing", "no_results", "complete"];
  const taskIndex = phaseOrder.indexOf(taskPhase);
  const currentIndex = phaseOrder.indexOf(currentPhase);

  if (currentIndex > taskIndex || currentPhase === "no_results") return "completed";
  if (currentIndex === taskIndex && currentPhase !== "initializing" && currentPhase !== "complete") return "active";
  return "pending";
};

export const formatTime = (ms: number): string => {
  const seconds = (ms / 1000).toFixed(1);
  return `${seconds}s`;
};
